module.exports = __webpack_public_path__ + "img/sticker.e92202e4.svg";